import { render, staticRenderFns } from "./AfterSaleItem.vue?vue&type=template&id=4c0cf569&"
import script from "./AfterSaleItem.vue?vue&type=script&lang=js&"
export * from "./AfterSaleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports